// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1s98A","container":"styles_container__37_66","title":"styles_title__1gJRJ","wrapper":"styles_wrapper__1FXZG","answer":"styles_answer__Wb6eV"};